export const sickLeaveTranslations = {
  page: {
      title: (type: "client"|"employee", employeeSick: boolean) => {
        if (type === "client") {
            return "Klienten Krankmeldung abschließen"
        }
        if (type === "employee" && employeeSick) {
            return "Mitarbeiter AU-Meldung abschließen"
        }
        if (type === "employee" && !employeeSick) {
            return "Kind AU-Meldung abschließen"
        }
        return "missing_translation"
      },
      successMessage: (type: "client"|"employee") => {
          switch (type) {
              case "employee":
                  return "AU-Meldung wurde erfolgreich gespeichert";
              case "client":
                  return "Krankmeldung wurde erfolgreich gespeichert"
              default:
                  return "missing_translation"
          }
      },
      backButton: 'Zurück zur Übersicht'
  },
  loading: {
    text: 'Lade Daten...',
    message: 'Daten werden geladen...'
  },
  status: {
    open: 'Offen'
  },
    sickLeaveType: (type: "client"|"employee", employeeSick: boolean) => {
        if (type === "client") {
            return "Klienten-Krankmeldung"
        }
        if (type === "employee" && employeeSick) {
            return "Mitarbeiter AU-Meldung"
        }
        if (type === "employee" && !employeeSick) {
            return "Kind AU-Meldung"
        }
        return "missing_translation"
    },
    title: (type: "client"|"employee", employeeSick: boolean, date: string, clientFirstName?: string, clientLastName?: string) : string => {
      if (type === "client") {
          return clientFirstName && clientLastName ? `${clientFirstName} ${clientLastName}` : 'den Klienten'
      }
      if (type === "employee" && employeeSick) {
          return `AU vom ${date}`
      }
      if (type === "employee" && !employeeSick) {
          return `Kind AU vom ${date}`
      }
      return "missing_translation"
    },
    message: (type: "client"|"employee", employeeSick: boolean, date: string, firstName?: string, lastName?: string)  => {
        if (type === "client") {
            return `Sie haben ${firstName && lastName ? `"${firstName} ${lastName}"` : 'den Klienten'} ab dem ${date} krank gemeldet. Bitte geben Sie das Enddatum der Krankmeldung an, sobald es bekannt ist.`
        }
        if (type === "employee" && employeeSick) {
            return 'Sie haben sich krank gemeldet. Bitte geben Sie das Enddatum der Krankmeldung an, sobald es bekannt ist.'
        }
        if (type === "employee" && !employeeSick) {
            return "Sie haben Ihr Kind krank gemeldet. Bitte geben Sie das Enddatum der Krankmeldung an, sobald es bekannt ist."
        }
        return "missing_translation"
    },
  form: {
      updateTitle: (type: "client"|"employee", employeeSick: boolean): string => {
        if (type === "client") {
            return "Klienten Krankmeldung aktualisieren"
        }
        if (type === "employee" && employeeSick) {
            return "AU-Meldung aktualisieren"
        }
        if (type === "employee" && !employeeSick) {
            return "Kind AU-Meldung aktualisieren"
        }
        return "missing_translation"
      },
    endDate: {
      label: 'Krank bis:',
      help: 'Leer lassen, wenn das Enddatum noch nicht bekannt ist. Bei einer eintägigen Krankmeldung können Sie das gleiche Datum wie das Startdatum wählen.'
    },
    eAu: {
      label: 'E-AU wird übermittelt'
    },
    sickNote: {
      label: (type: "client"|"employee", employeeSick: boolean) => {
          if (type === "client") {
              return "Krankmeldung:"
          }
          if (type === "employee" && employeeSick) {
              return "AU-Meldung:"
          }
          return "missing_translation"
      },
      uploaded: 'Dokument wurde hochgeladen',
      fileFormat: 'PDF, JPG oder PNG Format.'
    },
    buttons: {
      save: 'Speichern',
      finish: 'Abschließen',
      cancel: 'Abbrechen'
    },
    savingStatus: 'Wird gespeichert...'
  },
  modal: {
    save: {
        title: (type: "client"|"employee") => {
          if (type === "client") {
              return "Krankmeldung speichern"
          }
          if (type === "employee") {
              return "AU-Meldung speichern"
          }
          return "missing_translation"
        },
      message: (type: "client"|"employee") : string => {
            if (type === "client") {
                return 'Möchten Sie die Änderungen an der Krankmeldung speichern?'
            }
            if (type === "employee") {
                return 'Möchten Sie die Änderungen an der AU-Meldung speichern?'
            }
            return "missing_translation"
      },
      secondMessage: (type: "client"|"employee") : string => {
            if (type === "client") {
                return 'Die aktuellen Daten werden gespeichert und können später noch bearbeitet werden.'
            }
            if (type === "employee") {
                return 'Achtung. Die AU-Meldung kann nach dem Speichern nicht mehr bearbeitet werden.'
            }
            return "missing_translation"
      }
    },
    finish: {
      title: 'Krankmeldung abschließen',
      message: 'Möchten Sie die Krankmeldung wirklich abschließen?',
      secondMessage: 'Die Krankmeldung kann nach dem Abschließen nicht mehr bearbeitet werden. Stellen Sie bitte sicher, dass das „Krank bis“-Datum korrekt ist.'
    }
  }
};